module.exports = __webpack_public_path__ + "static/media/Manual_do_portal_do_TCC_Aluno.d54ef984.pdf";